import Vue from "vue";
import { findIndex } from "lodash";
import config from "@/config";
import { getCookie } from "../../cookie.js";
import { CHECKIN_FLOW_FLAG } from "@/common/const";

const API = config.apiAccount;

export default {
  state: {
    event: {},
    events: [],
    pastEvents: [],
    pastEventsCount: 0,
  },
  actions: {
    async getEventsList(ctx, ts_org_code) {
      const authorization = getCookie("user");
      const url = new URL(`${API}/events`);
      if (typeof ts_org_code !== "undefined") {
        url.searchParams.set("ts_org_code", ts_org_code);
      }
      const res = await fetch(url.toString(), {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: authorization,
        }),
      });
      if (!res.ok && res.status === 500)
        ctx.dispatch("handleToolbarNotification");
      if (!res.ok) return Promise.reject(`Server error. Status: ${res.status}`);
      const eventsList = await res.json();
      ctx.commit("updateEventsList", eventsList?.events || []);
      ctx.commit("setPastEventsCount", eventsList?.past_events);
    },
    async getPastEventsList(ctx) {
      const authorization = getCookie("user");
      const res = await fetch(`${API}/events/past`, {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: authorization,
        }),
      });
      if (!res.ok && res.status === 500)
        ctx.dispatch("handleToolbarNotification");
      if (!res.ok) return Promise.reject(`Server error. Status: ${res.status}`);
      const eventsList = await res.json();
      ctx.commit("updatePastEventsList", eventsList.events);
    },
    async getEvent(ctx, eventId) {
      const authorization = getCookie("user");
      let res = await fetch(`${API}/events/${eventId}`, {
        method: "GET",
        headers: new Headers({
          // "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: authorization,
        }),
      });
      if (!res.ok && res.status === 500)
        ctx.dispatch("handleToolbarNotification");
      if (!res.ok) return Promise.reject(`Server error. Status: ${res.status}`);
      let event = await res.json();
      // TODO: Get rid of this
      event.ticketCollection = {};
      if (event.tickets) {
        event.tickets.forEach((ticket) => {
          event.ticketCollection[ticket.id] = ticket;
        });
      }

      // Compute tickets needing checkin from BE data
      event.tickets_needing_checkin = (event.tickets || []).filter(
        (t) => t.checkin_status === "checkin_pending" || t.checkin_status === "unclaimed"
      ).length;

      ctx.commit("updateEvent", event);
    },
    updateEventTickets(ctx, data) {
      let event = ctx.state.event;
      if (!data) return;

      let ticketIndex = findIndex(event.tickets, { id: data.id });
      if (ticketIndex === -1) return;

      // TODO: Create mutation for this
      Vue.set(event.tickets, ticketIndex, {
        ...event.tickets[ticketIndex],
        ...data,
      });
      ctx.commit("updateEvent", event);
    },
  },
  mutations: {
    updateEvent(state, event) {
      state.event = event;
    },
    updateEventsList(state, list) {
      state.events = list;
    },
    setPastEventsCount(state, count) {
      state.pastEventsCount = count;
    },
    updatePastEventsList(state, list) {
      state.pastEvents = list;
    },
    setTicketProcessing(state, { barcode, status }) {
      let { event } = state;
      let ticketIndex = findIndex(event.tickets, { barcode });

      if (ticketIndex === -1) return;
      event.tickets[ticketIndex].processing = status;
    },
  },
  getters: {
    eventData(state) {
      return state.event;
    },
    isCheckinFlowEnabled(state) {
      return state.event?.[CHECKIN_FLOW_FLAG] === true;
    },
    // ids of events (from the events list) that use the new check-in flow
    checkinFlowEventIds(state) {
      return state.events
        .filter((event) => event?.[CHECKIN_FLOW_FLAG] === true)
        .map((event) => event.id);
    },
    eventsList(state) {
      return state.events;
    },
    pastEventsList(state) {
      return state.pastEvents;
    },
    hasPastEvents(state) {
      return state.pastEventsCount > 0;
    },
  },
};
